import { OptionTheme } from '../../types';

export const OPTION_DEFAULT_THEME: OptionTheme = {
    spacing: 16,
    paddingX: 16,
    paddingY: 16,
    iconSize: 24,
    actionIconSize: 20,
    radius: 5,
    fontSize: 'm',
    fontWeight: 'semiBold',
    colors: {
        background: 'background.content',
        hoverBackground: 'primary.tint.100',
        selectedBackground: 'primary.base',
        selectedText: 'common.white',
    },
};
